import { GlobalTooltip } from '@/dashboards/BudgetOptimization/components/ROICurves/tooltips/GlobalTooltip';
import { SelectedTooltip } from '@/dashboards/BudgetOptimization/components/ROICurves/tooltips/SelectedTooltip';
import { jsxToHtml } from '@/utils/reactUtils';
import React from 'react';

export type ROICurvesToolipParams = {
    seriesName: string;
    color: string;
    value: number;
    axisValueLabel: string;
}[];

export const renderTooltip =
    ({
        selected,
        investmentFormatter,
        contributionFormatter,
    }: {
        selected: string;
        contributionFormatter: (value: string | undefined | number) => string;
        investmentFormatter: (value: string | undefined | number) => string;
    }) =>
    (params: ROICurvesToolipParams) => {
        if (selected) {
            return jsxToHtml(
                <SelectedTooltip
                    params={params}
                    selectedSeriesName={selected}
                    investmentFormatter={(value) => {
                        return investmentFormatter(Number(value));
                    }}
                    contributionFormatter={(value) => {
                        return contributionFormatter(Number(value));
                    }}
                />,
            );
        }

        return jsxToHtml(
            <GlobalTooltip
                params={params}
                investmentFormatter={(value) => {
                    return investmentFormatter(Number(value));
                }}
                contributionFormatter={(value) => {
                    return contributionFormatter(Number(value));
                }}
            />,
        );
    };
